import * as PIXI from "pixi.js";

import { EventSystem } from "@src/core/events/EventSystem";
import { Button } from "@src/core/ui/components/Button";
import { constants } from "@src/game/Constants";

// This class represents the labeled info sections on the game UI (i.e. Balance 1000)
export class TitledButton {
  private _view: PIXI.Container = new PIXI.Container();
  public get view(): PIXI.Container {
    return this._view;
  }

  private _button!: Button;
  private _titleText!: PIXI.Text;
  public set titleText(title: string) {
    this._titleText.text = title;
  }
  private _buttonText!: PIXI.Text;

  private _title: string;
  private _text: string;
  public set buttonText(text: string) {
    this._buttonText.text = text;
  }

  public constructor(title: string, text: string, button: Button) {
    this._title = title;
    this._text = text;
    this._button = button;

    this._setupEventListeners();
    this._initializeAssets();
    this._parentAssets();
  }

  private _setupEventListeners(): void {
    EventSystem.addListener(
      constants.GameEvents.LANDSCAPE_LAYOUT_REQUESTED,
      this._onLandscapeLayoutRequested.bind(this),
    );

    EventSystem.addListener(
      constants.GameEvents.PORTRAIT_LAYOUT_REQUESTED,
      this._onPortraitLayoutRequested.bind(this),
    );
  }

  private _initializeAssets(): void {
    this._titleText = new PIXI.Text({
      text: this._title,
      style: {
        fill: "0xffffff",
        fontWeight: "bold",
        fontFamily: "uiFont",
        stroke: {
          color: "0x000000",
          width: 2,
        },
      },
    });
    this._titleText.style.align = "center";

    this._buttonText = new PIXI.Text({
      text: this._text,
      style: {
        fill: "0xffffff",
        fontWeight: "bold",
        fontFamily: "uiFont",
        stroke: {
          color: "0x000000",
          width: 2,
        },
      },
    });
    this._buttonText.anchor.set(0.5);
    this._buttonText.style.align = "center";
  }

  private _parentAssets(): void {
    this._view.addChild(this._button.view);
    this._view.addChild(this._titleText);
    this._view.addChild(this._buttonText);
  }

  private _onLandscapeLayoutRequested(): void {
    const landscapeSpacing: number = 20;

    this._buttonText.style.fontSize = 28;
    this._button.setScale(0.7);

    this._titleText.style.fontSize = 28;
    this._titleText.anchor.set(0, 0.5);
    this._titleText.position.set(
      -this._titleText.width - this._button.width / 2 - landscapeSpacing,
      0,
    );
  }

  private _onPortraitLayoutRequested(): void {
    this._buttonText.style.fontSize = 40;
    this._button.setScale(1);

    this._titleText.position.set(0, -65);
    this._titleText.style.fontSize = 40;
    this._titleText.anchor.set(0.5);
  }
}
